import { Scroll } from "@lib/scroll";
import { Pages } from "@lib/pages";
import { runInitial } from "@lib/pages";
import { tick } from "@/utils/tick";
import "@/utils/cls-resize";
import { isStaging } from "./webflow/is-staging";
import { listenForHubspotSubmit } from "./lib/hubspot-submit";

// history.scrollRestoration = "manual";

class _App {
  private scroll = Scroll;
  pages = Pages;

  constructor() {
    if (isStaging) {
      console.log("Runnig in development environment");
    }

    listenForHubspotSubmit();

    runInitial();
  }
}

export const App = new _App();
